import { requestLaravel } from "../../../../../../utils/api";
import { ApiResponse } from "../../../../core/_models";
import { IProblemTreeItem, IProblemTreeResponse } from "./types";

/** API route prefix of each stage with a problem tree; the stage's items are kept apart by the API. */
export type ProblemTreeStage = "project-stage-zero" | "project-stage-one";

export type SaveProblemTreeItemPayload = Omit<IProblemTreeItem, "item_id" | "category_names"> & {
    project_id: number;
    item_id: number | null;
};

export function getProblemTree(stage: ProblemTreeStage, project_id: string | number, signal?: AbortSignal) {
    return requestLaravel<ApiResponse<IProblemTreeResponse>>(`/${stage}/problem-tree/get`, { project_id }, { signal });
}

export function saveProblemTreeItem(stage: ProblemTreeStage, payload: SaveProblemTreeItemPayload) {
    return requestLaravel<ApiResponse<IProblemTreeItem>>(`/${stage}/problem-tree/items/save`, payload);
}

export function deleteProblemTreeItem(stage: ProblemTreeStage, item_id: number, project_id: number) {
    return requestLaravel<ApiResponse<{ item_id: number }>>(`/${stage}/problem-tree/items/delete`, { item_id, project_id });
}
